import { Divider, Typography } from "antd";

export const SettingTitle = ({ title, description }) => {
  return (
    <>
      <div style={{ fontSize: 24 }}>{title}</div>
      <Divider style={{ margin: "8px 0px" }} />
      {description && <Typography.Paragraph type="secondary">{description}</Typography.Paragraph>}
    </>
  );
};
